module.exports = __webpack_public_path__ + "static/media/icon-tier-complete-no-shadow.1f0c189e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon-tier-complete-no-shadow.svg
// module id = 366
// module chunks = 0